import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentPage from 'src/components/ContentPage/ContentPage';
import ReportingLinkList from 'src/features/siva/reporting/components/ReportingLinkList/ReportingLinkList';
import { ROUTES } from 'src/navigation';

const SivaAdminIndexPage: React.FC = () => {
  const { t: tCommon } = useTranslation();
  const { t: tSiva } = useTranslation('siva');
  const { t: tPageTitles } = useTranslation('pageTitles');
  return (
    <ContentPage title={tPageTitles('sivaReporting')}>
      <ReportingLinkList
        items={[
          { to: ROUTES.SIVA.ADMIN.GOALS.BASE, title: tSiva('targetNumber') },
          { to: ROUTES.SIVA.ADMIN.BUDGET, title: tCommon('budget') },
          { to: ROUTES.SIVA.ADMIN.FUNDS.BASE, title: tSiva('sivaAdmin.funds') },
        ]}
      />
    </ContentPage>
  );
};

export default SivaAdminIndexPage;
